import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Optimized with https://jakearchibald.github.io/svgomg/
 */
const SVGAddress = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 64 64"
    stroke="currentColor"
    {...props}
  >
    <title>Bormioli Pharma</title>
    <path
      d="M32.004 60S52 35.5 52 25 45.334 4 32.004 4C18.669 4 12 14.5 12 25s20.003 35 20.003 35"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.001 32c4.142 0 7.5-3.42 7.5-7.637s-3.358-7.636-7.5-7.636c-4.142 0-7.5 3.419-7.5 7.636 0 4.218 3.358 7.637 7.5 7.637Z"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGAddress;
